// ============================================================
// DEALIN MVP - Footer Component (Figma Design)
// ============================================================

import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8 sm:py-12 px-4 overflow-x-hidden">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="font-bold text-lg text-white ml-1">Dealin</span>
            </div>
            <p className="text-sm">
              La piattaforma AI per trovare il consulente ideale per la tua azienda.
            </p>
            <p className="text-xs text-gray-500 mt-2">DEALIN S.R.L. — P.IVA 06228210875</p>
            <a href="https://www.linkedin.com/company/dealin-srl/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="inline-block mt-3 text-gray-400 hover:text-white transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>

          {/* Prodotto */}
          <div>
            <h4 className="font-semibold text-white mb-4">Prodotto</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/home" className="hover:text-white transition-colors">Cerca Consulenti</Link></li>
              <li><Link to="/brief" className="hover:text-white transition-colors">AI Brief Builder</Link></li>
              <li><Link to="/consulenza" className="hover:text-white transition-colors">Aree di Consulenza</Link></li>
            </ul> 
          </div>

          {/* Azienda */}
          <div>
            <h4 className="font-semibold text-white mb-4">Azienda</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contatti</Link></li>
              <li><Link to="/richiesta-profilo" className="hover:text-white transition-colors">Reclama il tuo profilo</Link></li>
            </ul>
          </div>

          {/* Supporto */}
          <div>
            <h4 className="font-semibold text-white mb-4">Supporto</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="hover:text-white transition-colors">Centro Assistenza</Link></li>
              <li><a href="mailto:info@deal-in.it" className="hover:text-white transition-colors">info@deal-in.it</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs sm:text-sm text-center md:text-left">
          <p>&copy; {new Date().getFullYear()} DEALIN S.R.L. — P.IVA 06228210875. Tutti i diritti riservati.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Termini</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
